import axios from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from 'services';
import { notificationContainer } from 'utils/notificationContainer';
import {
	syncOrderShopifyRequest,
	syncOrderShopifySuccess,
	syncOrderWixRequest,
	syncOrderWixSuccess,
	syncOrderShopwareRequest,
	syncOrderShopwareSuccess,
} from './reducer';
import { TOrderSyncRequest } from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* syncOrderShopifyWorker(action: PayloadAction<TOrderSyncRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.ordersSync.syncShopify, payload);
		yield put(syncOrderShopifySuccess());
		notificationContainer('Order synced to Shopify successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'Request error',
				'error',
			);
		yield put(syncOrderShopifySuccess());
	}
}

function* syncOrderWixWorker(action: PayloadAction<TOrderSyncRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.ordersSync.syncWix, payload);
		yield put(syncOrderWixSuccess());
		notificationContainer('Order synced to Wix successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'Request error',
				'error',
			);
		yield put(syncOrderWixSuccess());
	}
}

function* syncOrderShopwareWorker(action: PayloadAction<TOrderSyncRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.ordersSync.syncShopware, payload);
		yield put(syncOrderShopwareSuccess());
		notificationContainer('Order synced to Shopware successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error))
			notificationContainer(
				error?.response?.data?.message ?? error.message ?? 'Request error',
				'error',
			);
		yield put(syncOrderShopwareSuccess());
	}
}

export function* ordersSyncSaga() {
	yield takeEvery(syncOrderShopifyRequest.type, syncOrderShopifyWorker);
	yield takeEvery(syncOrderWixRequest.type, syncOrderWixWorker);
	yield takeEvery(syncOrderShopwareRequest.type, syncOrderShopwareWorker);
}
